import { useState, useEffect, useCallback } from 'react';
import { TESTIMONIALS } from '@/lib/constants';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

export default function TestimonialSlider() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % TESTIMONIALS.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent(prev => (prev - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const t = TESTIMONIALS[current];

  return (
    <section className="py-24 md:py-32 bg-[#F4F4F5]" data-testid="testimonial-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#002FA7] mb-3">Testimonials</p>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight text-[#09090B] leading-tight">
            What Our Clients Say
          </h2>
        </div>

        <div className="max-w-3xl mx-auto" data-testid="testimonial-slider">
          <div className="bg-white border border-[#E4E4E7] p-8 md:p-12 relative">
            <Quote className="w-10 h-10 text-[#002FA7] opacity-20 mb-4" />
            <blockquote
              className="font-body text-lg md:text-xl text-zinc-700 leading-relaxed mb-8 min-h-[100px] transition-opacity duration-500"
              data-testid="testimonial-quote"
            >
              {t.quote}
            </blockquote>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#002FA7] flex items-center justify-center shrink-0">
                <span className="font-heading font-bold text-white text-lg">
                  {t.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <div>
                <p className="font-heading font-bold text-[#09090B]" data-testid="testimonial-name">{t.name}</p>
                <p className="text-sm text-zinc-500 font-body">{t.role}</p>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-between mt-6">
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrent(idx)}
                  className={`w-2.5 h-2.5 transition-colors ${
                    idx === current ? 'bg-[#002FA7]' : 'bg-zinc-300'
                  }`}
                  data-testid={`testimonial-dot-${idx}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button
                onClick={prev}
                className="w-10 h-10 border border-[#09090B] flex items-center justify-center hover:bg-[#09090B] hover:text-white transition-colors"
                data-testid="testimonial-prev"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                onClick={next}
                className="w-10 h-10 border border-[#09090B] flex items-center justify-center hover:bg-[#09090B] hover:text-white transition-colors"
                data-testid="testimonial-next"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
